<div #passwordpan fxLayout="column" class="layout-padd" [ngStyle]="{'max-height.px': innerHeight}">

 

  <mat-dialog-title fxLayoutAlign="center ">{{'clientpassComponent.changepass' | translate}}</mat-dialog-title>

  <form fxLayout="column" fxLayoutAlign="center center" fxLayoutAlignGap="40px" class="layout-padd-2" [formGroup]="passwordForm"
    #dirPassForm="ngForm" (ngSubmit)="submitNewPassword(dirPassForm, passwordpan)"   >

    <div fxLayout="column" class="full-w" style="padding-top:20px ;" fxLayoutGap="40px">
   
   
   
      <mat-form-field class="full-w">
      <mat-label>{{"myaccount.word.newpassword" | translate}}</mat-label>
      <input matInput type="password" (keydown.space)="$event.preventDefault()"
        placeholder="{{'myaccount.word.newpassword' | translate}}" formControlName="password" autocomplete="new-password" 
 name="password">
      <mat-error fxLayout fxLayoutAlign="start center" *ngIf="passwordForm.controls['password'].errors?.required">
        <span class="mat-caption">{{"main.err.reqpass" | translate}}</span>
      </mat-error>
      <mat-error fxLayout fxLayoutAlign="start center" *ngIf="passwordForm.controls['password'].errors?.minlength">
        <span class="mat-caption">{{"main.err.passformat" | translate}}</span>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="full-w">
      <mat-label>{{'main.word.verifpass' | translate}}</mat-label>
      <input matInput type="password" (keydown.space)="$event.preventDefault()"
        placeholder="{{'main.word.verifpass' | translate}}" formControlName="confPassword" autocomplete="new-password">
      <mat-error fxLayout fxLayoutAlign="start center" class="input-fullw"
        *ngIf="passwordForm.controls['confPassword'].errors?.required">
        <span class="mat-caption">{{"main.err.verifpassreq" | translate}}</span>
      </mat-error>
      <mat-error fxLayout fxLayoutAlign="start center" class="input-fullw"
        *ngIf="passwordForm.controls['confPassword'].errors?.MatchPassword">
        <span class="mat-caption">{{"main.err.nomatch" | translate}}</span>
      </mat-error>
    </mat-form-field>



   </div>
    <!--  btn bottom -->
    <div class="layout-padd positionBottom" fxLayoutGap="10px" fxflex>

      <button cdkFocusInitial type="submit" mat-raised-button color="primary" class=" rounded-button"
        fxFlex angulartics2On="click" angularticsAction="submitNewPasswordForm"
        angularticsCategory="passwordAccountDial">
        <span class="mat-title">{{"main.word.update"|translate}}</span>
      </button>

      <button (click)="closeDial()" mat-stroked-button class="dark-ico rounded-button" fxFlex angulartics2On="click"
      angularticsAction="closeNewPasswordForm" angularticsCategory="passwordAccountDial">
      <span class="mat-title">{{ "cancel_button"|translate}}</span>
    </button>

    </div>




  </form>


 

  <app-popup-loader [flagLoading]="loaders.forms" [size]="30" [statusMessage]="statusMessage">
  </app-popup-loader> 

</div> 
